import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { auth } from '@/firebase';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

axios.interceptors.request.use(async (config) => {
  const userIdToken = await auth.currentUser.getIdToken();

  /* eslint-disable-next-line no-param-reassign */
  config.headers = {
    ...config.headers,
    Authorization: `bearer ${userIdToken}`,
  };
  return config;
});

Vue.use(VueAxios, axios);
